
(() => {
  if (window.customImagePopupLoaded) return;
  window.customImagePopupLoaded = true;

  const openPopup = (src, alt) => {
    let popup = document.querySelector('#custom-image-popup');

    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'custom-image-popup';
      popup.innerHTML = `
        <button type="button" aria-label="Close image" class="custom-image-popup-close">&times;</button>
        <img alt="">
      `;
      popup.style.cssText = `
        position: fixed; inset: 0; z-index: 99999;
        background: rgba(0,0,0,.88); display: none;
        align-items: center; justify-content: center; padding: 50px 20px;
      `;
      const image = popup.querySelector('img');
      image.style.cssText = 'max-width: 95%; max-height: 90vh; object-fit: contain;';
      const close = popup.querySelector('button');
      close.style.cssText = 'position:absolute;top:15px;right:22px;font-size:38px;color:white;background:none;border:0;cursor:pointer;';
      close.addEventListener('click', () => {
        popup.style.display = 'none';
        document.body.style.overflow = '';
      });
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          popup.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
      document.body.appendChild(popup);
    }

    const image = popup.querySelector('img');
    image.src = src;
    image.alt = alt || 'Custom design example';
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  document.addEventListener('click', (event) => {
    const image = event.target.closest('img');
    if (!image) return;

    const pageTitle = document.querySelector('h1');
    if (!pageTitle || !pageTitle.textContent.toLowerCase().includes('custom designs')) return;

    const gallery = image.closest('.shopify-section');
    if (!gallery || !gallery.querySelectorAll('img').length) return;

    if (image.closest('a')) return;

    event.preventDefault();
    openPopup(image.currentSrc || image.src, image.alt);
  });
})();
